module.exports = __webpack_public_path__ + "static/media/green.17f6db2f.jpg";